import * as d3 from 'd3';

import { stackdata } from './StackData';
import { AugmentedLog } from '../../../models/index';
import { StackGenerator } from './StackGenerator';

export class StackedLogs {
    _stackGenerator: StackGenerator;
    private _svg: any;
    private _plotHeight: number;
    private _plotWidth: number;
    private _height: number;
    private _width: number;
    private _plotGroup: d3.Selection<any>;

    private _plotMargins = {
        top: 30,
        bottom: 60,
        left: 30,
        right: 30
    };

    private _panePlotHeight = 40;
    private _paneTitleHeight = 20;

    constructor(container: any) {
        this._svg = d3.select(container)
            .append('svg');

        const plotGroup = this._svg.append('g')
            .classed('plot', true)
            .attr('transform', `translate(${this._plotMargins.left},${this._plotMargins.top})`);
        this._plotGroup = plotGroup;
        this._stackGenerator = new StackGenerator();

    }

    size(value: { width: number, height: number }): this {
        this._width = value.width;
        this._height = value.height;
        this._svg.attr('width', this._width);
        this._plotWidth = this._width - this._plotMargins.left - this._plotMargins.right;
        this._plotHeight = this._height - this._plotMargins.top - this._plotMargins.bottom;
        this._stackGenerator.size({
            width: this._plotWidth,
            height: this._panePlotHeight
        });
        const applications = this._plotGroup.selectAll('.application');
        applications
            .select('text.title')
            .attr('transform', `translate(${this._plotWidth / 2},0)`);
        applications
            .selectAll('path')
            .call(this._stackGenerator.update);
        // let xAxis = d3.svg.axis()
        // .scale(d3.time.scale().domain(xDomain).range([0, this._plotWidth]));
        // applications.select('.x.axis')
        //     .call(xAxis);
        return this;
    }

    update(data: AugmentedLog[]) {
        const paneHeight = this._panePlotHeight + this._paneTitleHeight;
        const stacked = stackdata(data);
        const values = stacked.map(d => d.values);
        const flat = [].concat(...values);
        const xDomain = d3.extent(flat, d => d.x);
        const yDomain: [number, number] = [0, d3.max(flat, d => d.y + d.y0)];
        this._stackGenerator
            .xDomain(xDomain)
            .yDomain(yDomain);
        const byApplication = d3.nest<any>()
            .key(d => d.application)
            .entries(data)
            .sort((a, b) => d3.ascending(a.key, b.key));
        this._svg.attr('height', byApplication.length * paneHeight);
        const dataBound = this._plotGroup.selectAll('.application')
            .data(byApplication);
        dataBound
            .exit()
            .remove();
        const enterSelection = dataBound
            .enter()
            .append('g')
            .classed('application', true)
            .attr('transform', (d, i) => `translate(${0},${i * paneHeight})`);
        enterSelection.append('text')
            .classed('title', true)
            .attr('dy', '.35em');
        enterSelection.append('g')
            .classed('x', true)
            .classed('axis', true)
            .attr('transform', (d, i) => `translate(${0},${this._panePlotHeight})`);
        dataBound.select('text.title')
            .attr('transform', `translate(${this._plotWidth / 2},0)`)
            .text(d => d.key);
        dataBound
            .selectAll('path')
            .data(d => stackdata(d.values))
            .call(this._stackGenerator.render);
        const xAxis = d3.svg.axis()
            .scale(d3.time.scale().domain(xDomain).range([0, this._plotWidth]));
        dataBound.select('.x.axis')
            .call(xAxis);
    }
}
